import { Suspense, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { lazy } from 'utils/generic/lazy';
import { markAsReadNotification } from 'hooks/auth/useUserNotifications';
import { useEventbus } from 'newhooks/generic/useEventbus';
import { getIsLoggedIn, getUser } from 'store/selectors/user-data';
import { EAccountsEventbusKey } from '../constants';
import { IPopupDataWithId } from '../modals/PopupsCRM/type';

const { PopupsCRM } = lazy(
  () =>
    import(
      /* webpackChunkName: "accounts/generic/PopupsCRM" */ '../modals/PopupsCRM'
    )
);

export const AccountsGeneric = () => {
  const isLoggedIn = useSelector(getIsLoggedIn);
  const user = useSelector(getUser);
  const [popupsData, setPopupsData] = useState<IPopupDataWithId[]>([]);
  const currentPopup = popupsData[popupsData.length - 1];

  const isUserLoggedIn = isLoggedIn && !user.pending;

  const onPopupClose = useCallback(
    ({
      id,
      doNotRead
    }: {
      id: IPopupDataWithId['id'];
      doNotRead?: boolean;
    }) => {
      setPopupsData(prevPopups => {
        const newPopups = [...prevPopups].filter(popup => popup.id !== id);

        if (!doNotRead) {
          markAsReadNotification(id);
        }

        return newPopups;
      });
    },
    []
  );

  useEventbus({
    [EAccountsEventbusKey.POPUP_CRM_RECEIVED]: ({ payload }) => {
      if (payload) {
        setPopupsData(prevPopups => [...prevPopups, ...payload]);
      }
    }
  });

  if (!isUserLoggedIn) {
    return null;
  }

  if (!currentPopup) {
    return null;
  }

  return (
    <Suspense>
      <PopupsCRM popupData={currentPopup} onPopupClose={onPopupClose} />
    </Suspense>
  );
};
